
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledImgIcon = styled.img`
  width: ${(props) => props.width || 48}px;
  height: ${(props) => props.height || props.width || 48}px;
`;

StyledImgIcon.defaultProps = {
  width: 0,
  height: 0,
};
StyledImgIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default StyledImgIcon;